import NumberFormatter from '../number_formatter'
import _ from 'underscore'


export function BalanceFormatter() {
    this.constructor = BalanceFormatter;
}

/**
 * @param hoursPerDay
 * @param [roundToWholeNumberIfNeeded]
 * @param [isShowInHours]
 * @return {*}
 */
BalanceFormatter.prototype.init = function ( hoursPerDay, isShowInHours, roundToWholeNumberIfNeeded) {
    this._hoursPerDay = hoursPerDay;
    this._decimalSeparator =  window.SystemSettings.decimalSeparator;
    this._showBalanceInHours = isShowInHours;

    var roundToWholeNumber = !!roundToWholeNumberIfNeeded;
    this._daysFormatter = new NumberFormatter(this._decimalSeparator, window.SystemSettings.digitGroupingSymbol, roundToWholeNumber ? 0 : 2, true, '', 'd', 'N/A');
    this._hoursFormatter = new NumberFormatter(this._decimalSeparator, window.SystemSettings.digitGroupingSymbol, roundToWholeNumber ? 0 : 2, true, '', 'h', 'N/A');

    return this;
};

BalanceFormatter.prototype._recalculateFromDaysToHours = function(value) {
    return _.isNull(value) ? null : value * this._hoursPerDay;
};

BalanceFormatter.prototype.format = function(value, reverted) {
    var showInHours = reverted ? !this._showBalanceInHours : this._showBalanceInHours;
    if (showInHours)
        return this._hoursFormatter.format(this._recalculateFromDaysToHours(value));
    else
        return this._daysFormatter.format(value);
};

BalanceFormatter.prototype.isShowInHours = function()
{
    return this._showBalanceInHours;
};

BalanceFormatter.prototype.setShowInHours = function(showInHours)
{
    this._showBalanceInHours = showInHours;
};

BalanceFormatter.prototype.isNegativePTO = function(value, reverted) {
    var showInHours = reverted ? !this._showBalanceInHours : this._showBalanceInHours;
    if(showInHours)
        return this._hoursFormatter.isNegativeValue(this._recalculateFromDaysToHours(value));
    return this._daysFormatter.isNegativeValue(value);
};


//Sick Formatter
export function SickFormatter(){}

SickFormatter.prototype = _.create(BalanceFormatter.prototype,
{
    init: function(hoursPerDay, roundToWholeNumberIfNeeded)
    {
        BalanceFormatter.prototype.init.call(this, hoursPerDay, window.SystemSettings.showSickInHours, roundToWholeNumberIfNeeded);
        return this;
    }
});


//PTO Formatter
export function PTOFormatter(){}

PTOFormatter.prototype = _.create(BalanceFormatter.prototype,
{
    init: function(hoursPerDay, roundToWholeNumberIfNeeded)
    {
        BalanceFormatter.prototype.init.call(this, hoursPerDay, window.SystemSettings.showPTOInHours, roundToWholeNumberIfNeeded);
        return this;
    }
});



// WEBPACK FOOTER //
// ./web/js/util/BalanceFormatter.js